import React from "react";
import "../Card.scss";
import "./DefaultCard.scss";
import { Typography } from "@mui/material";
import { useIsMobile, View } from "hooks";

interface DefaultCardProps {
  children: React.ReactNode;
  title?: string;
}

function DefaultCard({ children, title }: DefaultCardProps) {
  const { view } = useIsMobile();
  return (
    <div
      className="card card-default"
      style={{ maxHeight: view === View.Mobile ? "80vh" : "75vh" }}
    >
      {title && (
        <div className="card-default-header card-header">
          <Typography variant="h3" textTransform="capitalize">
            {title}
          </Typography>
        </div>
      )}
      <div className="card-default-body">
        <div className="scroll-area">{children}</div>
      </div>
      <div className="card-footer">
        <br />
        <br />
        <Typography variant="caption">
          &copy; 2024 Harmony Hill, A Primitive Baptist Foundation, Inc.
        </Typography>
      </div>
    </div>
  );
}

export default DefaultCard;
